import React from 'react';
import mainLogo from '../assets/DAGGPT-01.png';

export function Logo() {
  return (
    <div className="flex items-center gap-2">
      <img 
        src={mainLogo} 
        alt="DAG GPT" 
        className="h-10 w-auto object-contain"
      />
      <span
        style={{
          background: '#ede9fe',
          color: '#7c3aed',
          fontSize: '9px',
          fontWeight: 800,
          padding: '2px 7px',
          borderRadius: '999px',
          letterSpacing: '0.05em',
        }}
      >
        BETA
      </span>
    </div>
  );
}
